// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-right-solid';

export const Component = () => (
  <path d='M4.928 9.381V5.454c0-.431.144-.766.431-1.054a1.408 1.408 0 0 1 1.054-.431h13.698c.431 0 .766.143 1.054.431.287.287.431.623.431 1.054V9.38c0 .383-.144.719-.431 1.006a1.411 1.411 0 0 1-1.054.431H6.413c-.431 0-.766-.144-1.054-.431a1.378 1.378 0 0 1-.43-1.006ZM2.485 20.636H20.11c.432 0 .767-.144 1.054-.431.288-.288.432-.623.432-1.054v-3.928c0-.43-.144-.766-.432-1.053a1.58 1.58 0 0 0-1.054-.383H2.485a1.58 1.58 0 0 0-1.054.383A1.408 1.408 0 0 0 1 15.223v3.928c0 .431.144.766.431 1.054.288.287.623.43 1.054.43ZM24.038 1c-.336 0-.48.191-.48.527v21.551c0 .335.144.479.48.479.335 0 .526-.144.526-.479V1.527c0-.336-.191-.527-.526-.527Z' />
);

export const viewBox = '0 0 25 25';
